import { CardAPI, config, debug } from "aaa";
import { find } from "lodash";
import { action, computed, observable } from "mobx";
import { IPin } from "types/card";
import { CardAPIClient } from "network/APIClient";
import { CardStore } from "stores/CardStore";
import { FEETYPE_PIN_REQUEST, IAmount } from "types/fee";
import { ISigningInfo, ISigningResponse } from "types/signing";

export type PinResetError = "None" | "FeeNotFound";

export default class PinResetStore {
    cardStore = new CardStore();

    // if signing is needed
    @observable signInfo?: ISigningInfo;

    @observable resetPinIsLoading: boolean = false;

    // Captcha image will be rendered afer signing is complete
    @observable signingResponse?: ISigningResponse;

    @observable pin?: IPin;

    // Returns true if waiting for card details info
    @computed get cardIsLoading(): boolean {
        return this.cardStore.isLoading;
    }

    @computed get pinRestoreFee(): IAmount | undefined {
        const fees = this.cardStore.cardFees;
        let constCardFee = find(fees, fee => {
            return fee.feeType === FEETYPE_PIN_REQUEST;
        });

        if (constCardFee) {
            return constCardFee.fee;
        } else {
            return undefined;
        }
    }

    @action load = (cardId: string) => {
        return this.cardStore.loadCardAndFees(cardId);
    }

    /**
     * Trigger pin reset using the displayPin API. Returns signing info
     * needed to sign and finish the request.
     */
    @action resetPin = async () => {
        if (!this.cardStore.card) {
            return;
        }

        const target = CardAPI.postPin(this.cardStore.card.id);
        this.resetPinIsLoading = true;

        try {
            this.signInfo = await CardAPIClient.requestType(target);
        } catch (e) {
            debug.log("### resetPin failed");
            throw e;
        } finally {
            this.resetPinIsLoading = false;
        }
    }

    @action getPin = async () => {
        if (!this.cardStore.card ||
            !this.signingResponse ||
            !this.signingResponse.domainServiceResponse.id) {
            return;
        }

        const target = CardAPI.getPin(this.cardStore.card.id, this.signingResponse.domainServiceResponse.id);
        this.pin = await CardAPIClient.requestType(target);

        debug.log("### getPin success", this.pin);
    }

    getProductString() {
        let productString = "BankCard";
        if (this.cardStore
            && this.cardStore.card
        ) {
            productString = this.cardStore.card.productI18N;
        }

        return productString;
    }

} 



// WEBPACK FOOTER //
// ./src/components/pin/stores/PinResetStore.ts